var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberThree = function SvgIconNumberThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5 3a1 1 0 0 1 1-1h9a1 1 0 0 1 .82 1.573L12.995 9.75a6.25 6.25 0 0 1 4.474 5.389 6.25 6.25 0 0 1-5 6.742 6.25 6.25 0 0 1-5.64-1.71 1 1 0 1 1 1.415-1.415A4.25 4.25 0 1 0 11.25 11.5a1 1 0 0 1-.82-1.573L14.58 4H7.5a1 1 0 0 1-1-1"
  })));
};
export default SvgIconNumberThree;